/**
 * O que se vê ao abrir um link de convite.
 *
 * Resolve-se o código ANTES de pedir login: quem recebe o link quer saber para
 * onde vai antes de criar conta. Um convite que só mostra um formulário de
 * registo é um convite que ninguém aceita.
 */

import type { InvitePreview } from "@greenvoice/shared";
import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useStore } from "../store/store";

export function InviteLanding({ code, onDone }: { code: string; onDone: () => void }) {
  const authStatus = useStore((s) => s.authStatus);
  const selectServer = useStore((s) => s.selectServer);

  const [preview, setPreview] = useState<InvitePreview | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    let alive = true;
    api.invites
      .resolve(code)
      .then((result) => {
        if (alive) setPreview(result);
      })
      .catch((caught: unknown) => {
        if (alive) setError((caught as Error).message);
      });
    return () => {
      alive = false;
    };
  }, [code]);

  async function accept() {
    setBusy(true);
    setError(null);
    try {
      const server = await api.invites.join(code);
      selectServer(server.id);
      onDone();
    } catch (caught) {
      setError((caught as Error).message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="invite-landing">
      <div className="invite-landing__card">
        {error ? (
          <>
            <h1>Convite inválido</h1>
            <p>{error}</p>
          </>
        ) : preview ? (
          <>
            <h1>{preview.server.name}</h1>
            <p>
              {preview.server.memberCount === 1 ? "1 membro" : `${preview.server.memberCount} membros`}
              {` · entra em #${preview.channel.name}`}
            </p>
            <p className="invite-landing__inviter">
              Convite de {preview.inviter.displayName ?? preview.inviter.username}
            </p>
            {authStatus === "authenticated" ? (
              <button type="button" className="button button--primary" disabled={busy} onClick={() => void accept()}>
                {busy ? "Entrando…" : "Aceitar convite"}
              </button>
            ) : (
              <p className="invite-landing__hint">Entre na sua conta para aceitar.</p>
            )}
          </>
        ) : (
          <p>Verificando o convite…</p>
        )}

        <button type="button" className="link" onClick={onDone}>
          Continuar sem aceitar
        </button>
      </div>
    </div>
  );
}
